exports = module.exports = require("../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".btn-add-company-program{\n    font-size: 13px;\n    padding-right: 2px;\n    padding-left: 2px;\n    margin-bottom: 2px;\n    cursor: pointer;\n}", ""]);

